export const isDateToday = (date: Date) => {
    const todayDate = new Date();
    return (todayDate.getFullYear() === date.getFullYear()) &&
        (todayDate.getMonth() === date.getMonth()) &&
        (todayDate.getDate() === date.getDate());
}